import './Thirdfloor.css'
import Footer from '../../components/Footer/Footer.jsx';
import ImageCard from '../../components/ImageCard/ImageCard.jsx';
import cab_14_1 from '../../images/Cab_photos/cab_14/1742984229317.jpg'
import cab_17_1 from '../../images/Cab_photos/cab_17/IMG20250325104451.jpg'
import cab_17_2 from '../../images/Cab_photos/cab_17/4.jpg'
import cab_18_1 from '../../images/Cab_photos/cab_18/IMG20250325104546.jpg'
import cab_18_2 from '../../images/Cab_photos/cab_18/IMG20250325104538.jpg'
import cab_18_4 from '../../images/Cab_photos/cab_18/1742984520468.jpg'
import cab_18_5 from '../../images/Cab_photos/cab_18/1742984520478.jpg'
import cab_19_1 from '../../images/Cab_photos/cab_19/IMG20250325112654.jpg'
import cab_19_2 from '../../images/Cab_photos/cab_19/IMG20250325112703.jpg'
import cab_20_1 from '../../images/Cab_photos/cab_20/IMG20250325112741.jpg'
import cab_20_2 from '../../images/Cab_photos/cab_20/IMG20250325112757.jpg'
import cab_21_1 from '../../images/Cab_photos/cab_21/IMG20250325112827.jpg'
import cab_21_2 from '../../images/Cab_photos/cab_21/IMG20250325112843.jpg'
import act from '../../images/Cab_photos/actzal/1.jpg'
import { Link } from 'react-router-dom';

function Thirdfloor() {
  return (
    <>
    <div className='wrap'>
    <div className="Thirdfloor">

        <ImageCard title={'Кабинет русского языка'} 
        images={[cab_14_1]}
        description={'Это просторная светлая комната с большими окнами. На стенах висят грамматические таблицы, наглядные пособия, высказывания писателей о русском языке, их портреты и плакаты. В шкафах хранятся книги, журналы и различные учебные пособия по русскому языку. Кабинет оснащён техническими средствами обучения.'}/>

        <ImageCard title={'Кабинет физики'} 
        images={[cab_17_2, cab_17_1 ]}
        description={'Это учебное помещение школы, оснащенное наглядными пособиями, учебным оборудованием, техническими средствами обучения, необходимыми при изучении данного предмета. Оно состоит из двух смежных комнат: классного помещения и лаборантской. В передней части кабинета расположен демонстрационный стол. Шкафы для хранения демонстрационного оборудования, оборудования для проведения лабораторно-практических работ обучающимися.'}/>

        <ImageCard title={'Кабинеты английского языка'} 
        images={[ cab_18_1, cab_18_2, cab_18_4, cab_18_5]}
        description={'Здесь проходят уроки английского языка факультативная и внеклассная работа с учащимися. В кабинете представлены разнообразные материалы (учебники, рабочие тетради, словари, грамматические книги), необходимые для изучения языка. Есть аудио- и видеооборудование для показа видео, презентаций и графики.'}/>

        <ImageCard title={'Кабинет технологии'} 
        images={[cab_19_2, cab_19_1 ]}
        description={'Здесь девочки знакомятся с правилами ведения домашнего хозяйства, учатся шить, осваивают навыки приготовления вкусной и здоровой пищи.'}/>

        <ImageCard title={'Кабинет географии'} 
        images={[cab_20_1, cab_20_2]}
        description={'Это учебное помещение, в котором проводят методическую, учебную, факультативную и внеклассную работу с учащимися.'}/>

        <ImageCard title={'Кабинет истории '} 
        images={[cab_21_1, cab_21_2]}
        description={'Он предназначен для проведения уроков истории и обществознания, а также внеурочной деятельности. Кабинет оснащён необходимыми средствами обучения: карты, картины, таблицы, альбомы, технические средства обучения.'}/>

        <ImageCard
        images={[act]}
        title={'Актовый зал'}
        description={'Актовый зал - это центр школьной жизни. Здесь проходят концерты, праздники, выпускные, ставятся спектакли, проводятся семинары. А ещё каждую неделю в актовом зале проходит еженедельная линейка , где подводятся итоги прошедшей недели, анонсируются мероприятия, проходит награждение лучших из лучших.'}/>
    </div>
    <div className='buttonwrap'>
    <div className="next-floor-button-container">
            <Link to="/Secondfloor" className="next-floor-button">
            ← Перейти на 2 этаж
            </Link>
    </div>
    <h3>Или</h3>
    <div className="next-floor-button-container">
            <Link to="/" className="next-floor-button">
              На главную
            </Link>
    </div>
    <h3>Или</h3>
    <div className="next-floor-button-container">
            <Link to="/About_school" className="next-floor-button">
              К истории школы
            </Link>
    </div>
    </div>
    </div>
    <Footer/>
    </>
  );
}

export default Thirdfloor;
